const ITEMS = [
  "Birra alla spina",
  "Hamburger gourmet",
  "Tacos francesi",
  "Tagliata di fassona",
  "DJ set nel weekend",
  "Aperto 19–02",
  "Nizza Monferrato",
];

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-[#141418] py-5"
      aria-hidden="true"
    >
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center">
            {ITEMS.map((t) => (
              <span
                key={`${copy}-${t}`}
                className="flex items-center font-display uppercase text-2xl sm:text-3xl tracking-wide text-stone-600"
              >
                <span className="mx-7">{t}</span>
                <span className="w-2 h-2 bg-[#D34E36] rotate-45 inline-block" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
